import { MIME_TYPE_MERGE_PATCH_JSON } from "@rumble-it/common-lib/src/constants/mimeTypes";
import { axiosInstance } from "../client";
import {
  ExternalWebhook,
  ExternalWebhookMethod,
} from "@rumble-it/common-lib/types/models/ExternalWebhook.interface";
import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";

export const fetchExternalWebhooks = async (): Promise<
  CollectionResponse<ExternalWebhook>
> =>
  axiosInstance
    .get(`/admin/external-webhooks`)
    .then((response) => response.data);

export const fetchExternalWebhookMethods = async (): Promise<
  CollectionResponse<ExternalWebhookMethod>
> =>
  axiosInstance
    .get(`/admin/external-webhooks/methods`)
    .then((response) => response.data);

export const createExternalWebhook = async (
  data: ExternalWebhook,
): Promise<ExternalWebhook> =>
  axiosInstance
    .post(`/admin/external-webhooks`, data)
    .then((response) => response.data);

export const updateExternalWebhookById = async (
  id: string,
  data: ExternalWebhook,
): Promise<null> =>
  axiosInstance
    .patch(`/admin/external-webhooks/${id}`, data, {
      headers: { "Content-Type": MIME_TYPE_MERGE_PATCH_JSON },
    })
    .then((response) => response.data);

export const deleteExternalWebhookById = async (id: string): Promise<null> =>
  axiosInstance
    .delete(`/admin/external-webhooks/${id}`)
    .then((response) => response.data);

export const fetchExternalWebhookById = async (
  id: string,
): Promise<ExternalWebhook> =>
  axiosInstance
    .get(`/admin/external-webhooks/${id}`)
    .then((response) => response.data);
